module.exports = __webpack_public_path__ + "static/launch-cfd01d02cbe2c4ca7fb3c6e2569500df.jpg";